import admin from "./admin";
import invoice from "./invoice/components";
import order from "./order/components";

// only the vue components that will be the parent component
// loaded into the blade need to be registered here in the imports
export default {
    ...admin,
    ...invoice,
    ...order,
};